import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { parseIpfsUrl } from "@/helpers/Helpers";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
interface NotificationHeaderProps {
  readonly author: ApiProfileMin;
  readonly children: React.ReactNode; // Content AFTER the user link (e.g. "replied • 2h")
  readonly actions?: React.ReactNode | undefined; // Follow button(s)
}
export default function NotificationHeader(t0) {
  const $ = _c(20);
  const {
    author,
    children,
    actions
  } = t0;
  let t1;
  if ($[0] !== author.handle || $[1] !== author.pfp) {
    t1 = <div className="tw-h-7 tw-w-7 tw-flex-shrink-0 tw-relative">{author.pfp ? <Image src={getScaledImageUri(parseIpfsUrl(author.pfp), ImageScale.W_AUTO_H_50)} alt={author.handle ?? "User profile"} fill={true} sizes="28px" className="tw-flex-shrink-0 tw-object-contain tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" /> : <div className="tw-flex-shrink-0 tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[0] = author.handle;
    $[1] = author.pfp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = author.handle ?? "";
  const t3 = `/${author.handle}`;
  let t4;
  if ($[3] !== author.handle || $[4] !== t3) {
    t4 = <Link href={t3} className="tw-no-underline tw-font-semibold tw-text-sm tw-text-iron-50">{author.handle}</Link>;
    $[3] = author.handle;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <UserProfileTooltipWrapper user={t2}>{t4}</UserProfileTooltipWrapper>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t5) {
    t6 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1">{t5}{children}</div>;
    $[9] = children;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== actions) {
    t7 = actions && <div className="tw-flex-shrink-0">{actions}</div>;
    $[12] = actions;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="tw-flex tw-flex-1 tw-flex-col tw-items-start min-[390px]:tw-flex-row min-[390px]:tw-justify-between min-[390px]:tw-items-center tw-gap-y-2 min-[390px]:tw-gap-x-2 tw-min-w-0">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t1 || $[18] !== t8) {
    t9 = <div className="tw-flex tw-items-start tw-gap-x-3">{t1}{t8}</div>;
    $[17] = t1;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}